






















































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType: string = "bom/materialCategoryList";

  dispatchTypeDelete: string = "bom/deleteMaterialCategory";
  deleteConfirmTitle: string = "你确定要删除该分类吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "类别名称", dataIndex: "name" },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  mounted() {
    this.loadData();
  }
}
